/* eslint-disable no-nested-ternary */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { MdModeEditOutline } from 'react-icons/md';

const TipsCard = ({ selected, onSelect, percent, amount, currency, isCustom, isFixed }) => {
  const { t } = useTranslation();

  return (
    <div
      role="button"
      onClick={() => onSelect(!selected)}
      className={`${
        selected ? 'bg-successLight border-primary' : 'bg-lightGrayBg border-lightGrayBg'
      } rounded-lg w-20 h-[4.5rem] border py-3 px-2 cursor-pointer
        ${isFixed ? 'flex items-center justify-center' : 'flex flex-col justify-between'}`}
    >
      {!isFixed && (
        <p className="font-primaryMedium text-bland text-sm">
          {isCustom ? t('checkout.customCardTitle') : `${percent} %`}
        </p>
      )}
      <p className="font-primaryMedium text-primary text-base whitespace-nowrap">
        {isCustom ? (
          <MdModeEditOutline />
        ) : isFixed ? (
          `${amount} ${currency}`
        ) : (
          `${amount.toFixed(2)} ${currency}`
        )}
      </p>
    </div>
  );
};

export default TipsCard;
